export const formatSSN = (value?: string | null) => value ? `${value}`.replace(/\D/g, "")
  .replace(/^(\d{3})(\d{2})(\d{4}).*/, "***-**-$3") : "";

export const formatTIN = (value?: string | null) => value ? `${value}`.replace(/\D/g, "")
  .replace(/^(\d{3})(\d{2})(\d{4}).*/, "**-***$3") : "";

const amountFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  currencySign: "accounting",
});

export const formatAmount = (value?: number | null) => (value !== null && value !== undefined)
  ? amountFormatter.format(value)
  : "";

export const metersToMillage = (v?: number | null) => {
  if (v !== null && v !== undefined) {
    return Number((v / 1600).toFixed(2));
  }
  return v;
};

export const millageToMeters = (v?: number | null) => {
  if (!Number.isNaN(Number(v))) {
    return Math.ceil((v || 0) * 1600);
  }
  return v;
};

export const minutesToHHMM = (v?: number | null) => {
  const hours = Math.floor((v || 0) / 60) || "0";
  const minutes = (v || 0) % 60 || "0";
  return `${hours.toString()
    .padStart(2, "0")}:${minutes.toString()
    .padStart(2, "0")}`;
};

export const stringToBoolean = (string: string | null | undefined) => {
  switch (string?.toLowerCase()
    ?.trim()) {
    case "true":
    case "yes":
    case "1":
      return true;

    case "false":
    case "no":
    case "0":
    case null:
      return false;

    default:
      return Boolean(string);
  }
};

export const capitalizeFirstLetter = (string: string) => string.charAt(0)
  .toUpperCase() + string.slice(1);

export const minutesToHours = (v?: number | null) => {
  return (v || 0) / 60;
};

export const hoursToMinutes = (v?: number | null) => {
  return Math.ceil((v || 0) * 60);
};

export function formatBytes(bytes: number | null | undefined, decimals = 2) {
  if (bytes === null || bytes === undefined || !+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = [ "Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB" ];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}